/**
 * Build a filesystem-safe PDF filename by joining the provided parts with
 * " - " and appending ".pdf". Empty/nullish parts are skipped, and characters
 * disallowed in filenames on Windows (\ / : * ? " < > |) are replaced with
 * underscores.
 *
 * Example:
 *   getPdfFileName('Math Assessment: Q1', 'Item Analysis')
 *     => 'Math Assessment_ Q1 - Item Analysis.pdf'
 */
export function getPdfFileName(...parts: (string | null | undefined)[]): string {
    const cleaned = parts
        .map((p) => (p ?? '').replace(/[\\/:*?"<>|]/g, '_').trim())
        .filter((p) => p.length > 0);
    const name = cleaned.length > 0 ? cleaned.join(' - ') : 'Report';
    return `${name}.pdf`;
}
